<template>
    <div class="jump-tabbar">
        <van-tabbar  active-color="#3c6eeb" v-model="tabActive">
            <van-tabbar-item  url="#/home">
                <i slot="icon" class="iconfont icon-shouye"></i>
            首页</van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/cate">
                <i slot="icon" class="iconfont icon-icon-"></i>
                分类</van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/message/center">
                <i slot="icon" class="iconfont icon-ico_msg"></i>
                消息</van-tabbar-item>
            <van-tabbar-item icon="cart-o" url="#/cart">
                <i slot="icon" class="iconfont icon-gouwuche1"></i>
                购物车</van-tabbar-item>
            <van-tabbar-item icon="contact" url="#/usercent">
                <i slot="icon" class="iconfont icon-ziyuan2"></i>
                我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
import { Tabbar, TabbarItem } from 'vant';
export default {
    name:"TabMenu",
    components:{
        [Tabbar.name]:Tabbar,
        [TabbarItem.name]:TabbarItem
    },
    props: {
        //tabActive: 5
    },
    data () {
        return {
            tabActive: 1
        }
    }    
}
</script>
<style lang="less">

</style>

